import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useVoiceWidget } from '@/context/VoiceWidgetContext';
import { Button } from '@/components/ui/button';

export default function VoiceAssistantWidget() {
    const { isOpen, closeWidget } = useVoiceWidget();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        className="relative w-full max-w-6xl h-[85vh] bg-black rounded-2xl overflow-hidden shadow-2xl border border-white/10"
                    >
                        {/* Header/Close Button */}
                        <div className="absolute top-4 right-4 z-10">
                            <Button
                                variant="secondary"
                                size="icon"
                                onClick={closeWidget}
                                className="rounded-full bg-black/50 hover:bg-black/70 text-white border border-white/20"
                            >
                                <X className="w-5 h-5" />
                            </Button>
                        </div>

                        {/* Iframe */}
                        <iframe
                            src="https://cara-voice.web.app"
                            className="w-full h-full border-0"
                            title="Voice Assessment"
                            allow="microphone"
                        />
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
